module.exports = __webpack_public_path__ + "app/assets/images/woman1-fd24411d2739e1f30ad28b39ccfeedd1.jpg";